export default "__VITE_ASSET__349a98c5__"